import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { useUserAccounts } from 'modules/payments/hooks/use-user-accounts';
import React, { FC } from 'react';
import RedeemIcon from '@mui/icons-material/Redeem';
import { MAIN_CURRENCY } from '@okletsplay/core';
import { FormatCurrency, FormatCurrencyType } from 'shared/components/Format/Currency';

interface ComponentProps {
  variant?: 'large' | 'small';
}

export const RewardBalance: FC<ComponentProps> = ({ variant = 'large' }) => {
  const { mainAccountRewardBalance } = useUserAccounts();

  const theme = useTheme();

  if (!mainAccountRewardBalance) {
    return null;
  }

  return (
    <Tooltip title="Reward Balance paid from Affiliate Program">
      <Box
        display="flex"
        alignItems="center"
        sx={{ cursor: 'default', color: theme.palette.primary.light }}
      >
        <RedeemIcon fontSize={variant} />
        <Box display="flex" flexDirection="column" ml={1}>
          <Typography variant={variant === 'small' ? 'subtitle2' : undefined}>
            <FormatCurrency
              amount={mainAccountRewardBalance}
              currency={MAIN_CURRENCY}
              type={FormatCurrencyType.Crypto}
            />
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};
